import { applyClickjackProtection } from 'utils/clickjackProtection'

// Keep clickjack checks in the first entry chunk so they run before bootstrap loading.
applyClickjackProtection()
import('./bootstrap')

export {}
